module.exports = __webpack_public_path__ + "static/media/second.09c20b20.png";